import { render, staticRenderFns } from "./Curricula.vue?vue&type=template&id=2499d27d&"
import script from "./Curricula.vue?vue&type=script&lang=js&"
export * from "./Curricula.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports